import { render, staticRenderFns } from "./BarangayImportsList.vue?vue&type=template&id=14053458"
import script from "./BarangayImportsList.vue?vue&type=script&lang=js"
export * from "./BarangayImportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports